import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  useTheme,
  Snackbar,
  Alert,
} from "@mui/material";
import UsersTable from "./UsersTable";
import DeleteDialog from "./DeleteDialog";
import { useUsers } from "../hooks/useUsers";

const Users = ({
  searchQuery,
  filter,
  orderFilter,
  monthFilter,
  refreshTrigger,
  onLoadingChange,
}) => {
  const theme = useTheme();
  const {
    filteredUsers,
    totalUsers,
    paidCount,
    unpaidCount,
    testCount,
    loading,
    openDialog,
    setOpenDialog,
    userToDelete,
    setUserToDelete,
    hasMore,
    observerRef,
    handleRefresh,
    handleDeleteUser,
    handleUpdateDiscount,
    handleUpdateTags,
    handleRenewalNotified,
    setSearchQuery,
    handleUpdateUser,
  } = useUsers(filter, undefined, orderFilter, monthFilter);

  useEffect(() => {
    onLoadingChange?.(loading);
  }, [loading, onLoadingChange]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const isFirstRefresh = useRef(true);

  useEffect(() => {
    if (isFirstRefresh.current) {
      isFirstRefresh.current = false;
      return;
    }
    handleRefresh();
  }, [refreshTrigger, handleRefresh]);
  useEffect(() => {
    setSearchQuery(searchQuery);
  }, [searchQuery, setSearchQuery]);
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        width: "100%",
        overflowX: "hidden",
      }}
    >
      {" "}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {" "}
        <Box
          sx={{
            p: { xs: 1.5, sm: 3 },
            maxWidth: "100%",
            width: "100%",
            backgroundColor: theme.palette.background.paper,
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: { xs: "flex-start", sm: "space-between" },
              mb: { xs: 1.5, sm: 3 },
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, color: theme.palette.text.primary, lineHeight: 1.3 }}
              >
                Total: {totalUsers} usuários
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "0.8125rem",
                  color: theme.palette.text.secondary,
                  mt: 0.5,
                  lineHeight: 1.5,
                }}
              >
                {" "}
                <span
                  style={{
                    display: "inline-block",
                    width: "8px",
                    height: "8px",
                    backgroundColor: "green",
                    borderRadius: "50%",
                    marginRight: "4px",
                  }}
                />{" "}
                Pagos: {paidCount} •{" "}
                <span
                  style={{
                    display: "inline-block",
                    width: "8px",
                    height: "8px",
                    backgroundColor: "orange",
                    borderRadius: "50%",
                    marginLeft: "8px",
                    marginRight: "4px",
                  }}
                />{" "}
                Não Pagos: {unpaidCount} •{" "}
                <span
                  style={{
                    display: "inline-block",
                    width: "8px",
                    height: "8px",
                    backgroundColor: "#42a5f5",
                    borderRadius: "50%",
                    marginLeft: "8px",
                    marginRight: "4px",
                  }}
                />{" "}
                Teste: {testCount}{" "}
              </Typography>{" "}
            </Box>{" "}
          </Box>{" "}
          {loading && filteredUsers.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 8,
              }}
            >
              <CircularProgress sx={{ color: theme.palette.primary.main }} />
            </Box>
          ) : filteredUsers.length > 0 ? (
            <UsersTable
              users={filteredUsers}
              onDelete={(id) => {
                setUserToDelete(id);
                setOpenDialog(true);
              }}
              onUpdateDiscount={handleUpdateDiscount}
              onUpdateTags={handleUpdateTags}
              onRenewalNotified={handleRenewalNotified}
              onUpdateUser={handleUpdateUser}
            />
          ) : (
            <Typography sx={{ textAlign: "center", mt: 4 }}>
              Nenhum usuário encontrado.
            </Typography>
          )}
          {hasMore && filteredUsers.length > 0 && (
            <Box
              ref={observerRef}
              sx={{
                display: "flex",
                justifyContent: "center",
                py: 3,
                height: "200px",
                minHeight: "200px",
              }}
            >
              {" "}
              <CircularProgress
                sx={{ color: theme.palette.primary.main }}
              />{" "}
            </Box>
          )}{" "}
        </Box>{" "}
        <DeleteDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onConfirm={() => {
            handleDeleteUser(userToDelete);
            setOpenDialog(false);
          }}
          user={filteredUsers.find((u) => u.id === userToDelete)}
        />{" "}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={5000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>{" "}
    </Box>
  );
};
export default Users;
